// Web mock for react-native-keychain using localStorage
const KEYCHAIN_PREFIX = '__keychain_';

export async function setGenericPassword(
  username: string,
  password: string,
  options?: any
): Promise<boolean> {
  try {
    const service = options?.service || 'default';
    localStorage.setItem(
      `${KEYCHAIN_PREFIX}${service}`,
      JSON.stringify({ username, password })
    );
    return true;
  } catch {
    return false;
  }
}

export async function getGenericPassword(
  options?: any
): Promise<false | { username: string; password: string; service: string }> {
  try {
    const service = options?.service || 'default';
    const data = localStorage.getItem(`${KEYCHAIN_PREFIX}${service}`);
    if (data) {
      const parsed = JSON.parse(data);
      return { ...parsed, service };
    }
    return false;
  } catch {
    return false;
  }
}

export async function resetGenericPassword(options?: any): Promise<boolean> {
  try {
    const service = options?.service || 'default';
    localStorage.removeItem(`${KEYCHAIN_PREFIX}${service}`);
    return true;
  } catch {
    return false;
  }
}

export async function hasInternetCredentials(server: string): Promise<boolean> {
  return !!localStorage.getItem(`${KEYCHAIN_PREFIX}internet_${server}`);
}

export async function setInternetCredentials(
  server: string,
  username: string,
  password: string
): Promise<boolean> {
  try {
    localStorage.setItem(
      `${KEYCHAIN_PREFIX}internet_${server}`,
      JSON.stringify({ username, password })
    );
    return true;
  } catch {
    return false;
  }
}

export async function getInternetCredentials(
  server: string
): Promise<false | { username: string; password: string; server: string }> {
  try {
    const data = localStorage.getItem(`${KEYCHAIN_PREFIX}internet_${server}`);
    if (data) {
      const parsed = JSON.parse(data);
      return { ...parsed, server };
    }
    return false;
  } catch {
    return false;
  }
}

export async function resetInternetCredentials(server: string): Promise<boolean> {
  try {
    localStorage.removeItem(`${KEYCHAIN_PREFIX}internet_${server}`);
    return true;
  } catch {
    return false;
  }
}

export const ACCESSIBLE = {
  WHEN_UNLOCKED: 'AccessibleWhenUnlocked',
  AFTER_FIRST_UNLOCK: 'AccessibleAfterFirstUnlock',
  ALWAYS: 'AccessibleAlways',
  WHEN_PASSCODE_SET_THIS_DEVICE_ONLY: 'AccessibleWhenPasscodeSetThisDeviceOnly',
  WHEN_UNLOCKED_THIS_DEVICE_ONLY: 'AccessibleWhenUnlockedThisDeviceOnly',
  AFTER_FIRST_UNLOCK_THIS_DEVICE_ONLY: 'AccessibleAfterFirstUnlockThisDeviceOnly',
};

export const ACCESS_CONTROL = {
  USER_PRESENCE: 'UserPresence',
  BIOMETRY_ANY: 'BiometryAny',
  BIOMETRY_CURRENT_SET: 'BiometryCurrentSet',
  DEVICE_PASSCODE: 'DevicePasscode',
  APPLICATION_PASSWORD: 'ApplicationPassword',
  BIOMETRY_ANY_OR_DEVICE_PASSCODE: 'BiometryAnyOrDevicePasscode',
  BIOMETRY_CURRENT_SET_OR_DEVICE_PASSCODE: 'BiometryCurrentSetOrDevicePasscode',
};

export const AUTHENTICATION_TYPE = {
  DEVICE_PASSCODE_OR_BIOMETRICS: 'AuthenticationWithBiometricsDevicePasscode',
  BIOMETRICS: 'AuthenticationWithBiometrics',
};

export const BIOMETRY_TYPE = {
  TOUCH_ID: 'TouchID',
  FACE_ID: 'FaceID',
  FINGERPRINT: 'Fingerprint',
  FACE: 'Face',
  IRIS: 'Iris',
};

export const SECURITY_LEVEL = {
  ANY: 'SECURE_SOFTWARE',
  SECURE_SOFTWARE: 'SECURE_SOFTWARE',
  SECURE_HARDWARE: 'SECURE_HARDWARE',
};

export async function getSupportedBiometryType(): Promise<string | null> {
  return null;
}

export default {
  setGenericPassword,
  getGenericPassword,
  resetGenericPassword,
  hasInternetCredentials,
  setInternetCredentials,
  getInternetCredentials,
  resetInternetCredentials,
  getSupportedBiometryType,
  ACCESSIBLE,
  ACCESS_CONTROL,
  AUTHENTICATION_TYPE,
  BIOMETRY_TYPE,
  SECURITY_LEVEL,
};
